<template>
	<div
		v-if="videoObject"
		:id="`block-${$vnode.key}`"
		class="c-block-list-video"
		:class="{
			'c-block-list-video--wide': fullWidthView,
		}"
	>
		<LongReadTarget
			v-if="title"
			class="relative mb-2xs/v z-10"
			:container-id="`block-${$vnode.key}`"
			:link-to-toc="{
				name: `Spring til &quot;${title}&quot; i indholdsfortegnelsen`,
				attrs: {
					'data-focus-ignore': true,
				},
			}"
			:title="title"
			:disabled="!showTitleInToc"
		>
			<BaseH2 :id="`block-${$vnode.key}__title`" v-html="title" />
		</LongReadTarget>

		<CookieInformationBlocker
			:categories="
				[
					statistic && 'statistic',
					functional && 'functional',
					marketing && 'marketing',
				].filter(Boolean)
			"
		>
			<VideoPlayer
				class="c-block-list-video__video bg-theme"
				:picker="videoObject"
				:aria-describedby="
					text ? `block-${$vnode.key}__description` : null
				"
				embed-on-play
			>
				<template #overlay="{ overlay, service }">
					<button
						:id="`block-${$vnode.key}__overlay-button`"
						:class="[
							'group flex justify-center items-center',
							'relative w-full h-full',
							'duration-300 delay-200 ease-smooth-out',
							{
								'opacity-0 pointer-events-none':
									!overlay.isVisible,
							},
						]"
						:aria-labelledby="overlayLabel"
						:aria-describedby="
							text ? `block-${$vnode.key}__description` : null
						"
						@click.prevent="
							() => {
								service.play(overlay.hide);
								loading = true;
							}
						"
					>
						<img
							v-if="service.poster"
							:src="service.poster"
							:class="[
								'absolute top-0 left-0',
								'w-full h-full object-cover',
								'mix-blend-luminosity opacity-20',
							]"
						/>

						<BaseButton
							tag="div"
							class="
								relative
								px-sm/h
								bg-white
								group-hover:bg-theme-10
								text-theme
							"
							v-text="'Afspil'"
						/>
					</button>
				</template>
			</VideoPlayer>
		</CookieInformationBlocker>

		<div
			v-if="text"
			:id="`block-${$vnode.key}__description`"
			:class="[
				'mt-4xs/v >=768:mt-2xs/v',
				'text-gray-darker text-body-xs whitespace-pre-wrap',
			]"
			v-html="text"
		></div>
	</div>
</template>

<script>
import CookieInformationBlocker from '~/components/main/CookieInformationBlocker';
import { LongReadTarget } from '~/components/shared/LongRead';
import { VideoPlayer } from '~/components/shared/VideoPlayer';

export default {
	name: 'BlockListVideo',

	components: { CookieInformationBlocker, LongReadTarget, VideoPlayer },

	inheritAttrs: false,

	props: {
		title: String,
		showTitleInToc: Boolean,
		text: String,

		video: Array,
		fullWidthView: Boolean,
	},

	data() {
		return {
			loading: false,
		};
	},

	computed: {
		statistic() {
			return this.video?.[0]?.content?.statistic;
		},
		functional() {
			return this.video?.[0]?.content?.functional;
		},
		marketing() {
			return this.video?.[0]?.content?.marketing;
		},

		videoAlias() {
			return this.video?.[0]?.alias || 'blockYouTube';
		},
		videoObject() {
			return this.video?.[0]?.content?.video;
		},

		overlayLabel() {
			const list = [
				`block-${this.$vnode.key}__overlay-button`,
				this.title && `block-${this.$vnode.key}__title`,
			];
			return list.filter(Boolean).join(' ');
		},
	},
};
</script>

<style lang="postcss">
.c-block-list-video--wide {
	@apply w-12/12col justify-self-end;
}
.c-block-list-video__video {
	aspect-ratio: 16 / 9;
}
</style>
